export const saveEditableRecord = async ({
  service,
  item = {},
  editItem = {},
  defaultValues = {},
}) => {
  if (!service) throw new Error("Servicio no disponible");

  const data = { ...editItem, ...item, ...defaultValues };
  const id = item?.id || editItem?.id;

  return id ? service.update(id, data) : service.create(data);
};
